import {
  ChatRole,
  CompetitionGroup,
  MatchStatus,
} from '@plvs/graphql/generated'
import { MatchTeamForRenderController } from '../../match/types/matchRenderController.types'
import { UserRolesForMatchLobbyRenderController } from '../../MatchLobbyRenderController.types'

export type ChatComponentProps = {
  userRoles: UserRolesForMatchLobbyRenderController
  myTeams: MatchTeamForRenderController[]
  competitionGroup: CompetitionGroup | null | undefined
  status: MatchStatus | null | undefined
}

export type ChatComponentReturn = {
  chatRole: ChatRole
  chatTabs: string[]
}

export type ChatRenderController = {
  getChatComponentsToRender: ({
    userRoles,
    myTeams,
    competitionGroup,
    status,
  }: ChatComponentProps) => ChatComponentReturn
}

export enum ChatTab {
  All = 'all',
  Coach = 'coach',
}
